module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "snapNodesToGridCheckbox"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.snapNodesToGrid),
      expression: "value.snapNodesToGrid"
    }],
    attrs: {
      "type": "checkbox",
      "id": "snapNodesToGridCheckbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.value.snapNodesToGrid) ? _vm._i(_vm.value.snapNodesToGrid, null) > -1 : (_vm.value.snapNodesToGrid)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.value.snapNodesToGrid,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.value, "snapNodesToGrid", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.value, "snapNodesToGrid", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.value, "snapNodesToGrid", $$c)
        }
      }
    }
  }), _vm._v("\n                Snap nodes to grid\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "snapGridSizeEdit"
    }
  }, [_vm._v("Snap grid size")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.snapGridSize),
      expression: "value.snapGridSize"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "value": "50",
      "id": "snapGridSizeEdit",
      "placeholder": "Enter snap grid size",
      "required": ""
    },
    domProps: {
      "value": (_vm.value.snapGridSize)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "snapGridSize", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "autoCreateShadowKinksCb"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.autoCreateKinkPoints),
      expression: "value.autoCreateKinkPoints"
    }],
    attrs: {
      "type": "checkbox",
      "id": "autoCreateShadowKinksCb"
    },
    domProps: {
      "checked": Array.isArray(_vm.value.autoCreateKinkPoints) ? _vm._i(_vm.value.autoCreateKinkPoints, null) > -1 : (_vm.value.autoCreateKinkPoints)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.value.autoCreateKinkPoints,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.value, "autoCreateKinkPoints", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.value, "autoCreateKinkPoints", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.value, "autoCreateKinkPoints", $$c)
        }
      }
    }
  }), _vm._v("\n                Create kink points in auto-layout\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onOkClick
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onCancelClick
    }
  }, [_vm._v("Cancel")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8508a50c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8508a50c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/network-diagram-options-dialog/network-diagram-options-dialog.vue.html
// module id = 1125
// module chunks = 0